import { START_LOADING, END_LOADING } from "./loading_actions";
import { getProductsAuth, getProducts } from "../../utils/api";
import { SET_PORTAL_API } from "./portal_actions";
import {
  TITLE_ERROR, TEXT_ERROR_NOT_AVAILABLE_PRODUCTS,
  TEXT_NOTIFICATION_ORDER_STRUCTURE, TITLE_NOTIFICATION
} from "../../utils/constants";
import { CATEGORIES_ADD_ROUTES } from "./categories_actions";
import { getArrayForRoutes, checkTransportedProducts, diffProductsLists } from "../../utils/util_functions";
import { SALE_PRODUCTS_SET, NEW_PRODUCTS_SET, POPULAR_PRODUCTS_SET } from "./sale_new_popular_actions";
import { NEW_ORDER_SET_PRODUCTS } from "./new_order_actions";
import { SET_CUSTOMER } from "./customer_actions";

export const GET_PRODUCTS_REQUEST = 'GET_PRODUCTS_REQUEST';
export const GET_PRODUCTS_SUCCESS = 'GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_FAILED = 'GET_PRODUCTS_FAILED';

export const getProductsThunk = (accessToken, refreshToken) => {
  return async (dispatch) => {
    dispatch({ type: START_LOADING });
    if (accessToken && refreshToken) {
      getProductsAuth(accessToken, refreshToken)
        .then(products => {
          dispatch({
            type: GET_PRODUCTS_SUCCESS,
            products
          });
          dispatch({
            type: CATEGORIES_ADD_ROUTES,
            routes: getArrayForRoutes(products)
          });
          dispatch({
            type: SALE_PRODUCTS_SET,
            payload: products.filter(
              product => product.action_price && product.action_price > 0 && product.in_archive === false
            )
          });
          dispatch({
            type: NEW_PRODUCTS_SET,
            payload: products.filter(product => product.new && product.in_archive === false)
          });
          dispatch({
            type: POPULAR_PRODUCTS_SET,
            payload: products.filter(product => product.popular && product.in_archive === false)
          });
        })
        .catch(error => {
          dispatch({ type: GET_PRODUCTS_FAILED });
          console.log(error);
          dispatch({
            type: SET_PORTAL_API,
            title: TITLE_ERROR,
            text: Object.values(error)
          });
        })
        .finally(() => {
          dispatch({ type: END_LOADING });
        });
    } else {
      getProducts()
        .then(products => {
          dispatch({
            type: GET_PRODUCTS_SUCCESS,
            products
          });
          dispatch({
            type: CATEGORIES_ADD_ROUTES,
            routes: getArrayForRoutes(products)
          });
          dispatch({
            type: SALE_PRODUCTS_SET,
            payload: products.filter(
              product => product.action_price && product.action_price > 0 && product.in_archive === false
            )
          });
          dispatch({
            type: NEW_PRODUCTS_SET,
            payload: products.filter(product => product.new && product.in_archive === false)
          });
          dispatch({
            type: POPULAR_PRODUCTS_SET,
            payload: products.filter(product => product.popular && product.in_archive === false)
          });
        })
        .catch(error => {
          dispatch({ type: GET_PRODUCTS_FAILED });
          console.log(error);
          dispatch({
            type: SET_PORTAL_API,
            title: TITLE_ERROR,
            text: Object.values(error)
          });
        })
        .finally(() => {
          dispatch({ type: END_LOADING });
        });
    }
  }
}


export const getProductsAndTransportedThunk = (
  accessToken, refreshToken, products_set, customer, navigate, order = null
) => {
  return async (dispatch) => {
    dispatch({ type: START_LOADING });
    getProductsAuth(accessToken, refreshToken)
      .then(products => {
        dispatch({
          type: GET_PRODUCTS_SUCCESS,
          products
        });
        dispatch({
          type: CATEGORIES_ADD_ROUTES,
          routes: getArrayForRoutes(products)
        });
        dispatch({
          type: SALE_PRODUCTS_SET,
          payload: products.filter(
            product => product.action_price && product.action_price > 0 && product.in_archive === false
          )
        });
        dispatch({
          type: NEW_PRODUCTS_SET,
          payload: products.filter(product => product.new && product.in_archive === false)
        });
        dispatch({
          type: POPULAR_PRODUCTS_SET,
          payload: products.filter(product => product.popular && product.in_archive === false)
        });
        dispatch({
          type: SET_CUSTOMER,
          customer: customer
        });

        const actualProductsList = checkTransportedProducts(products, products_set, customer);
        if (actualProductsList.length === 0) {
          dispatch({
            type: SET_PORTAL_API,
            title: TITLE_ERROR,
            text: TEXT_ERROR_NOT_AVAILABLE_PRODUCTS
          });
          return;
        } else {
          if (diffProductsLists(products_set, actualProductsList).length > 0) {
            dispatch({
              type: SET_PORTAL_API,
              title: TITLE_NOTIFICATION,
              text: TEXT_NOTIFICATION_ORDER_STRUCTURE
            });
          }
          dispatch({
            type: NEW_ORDER_SET_PRODUCTS,
            payload: actualProductsList
          });
          navigate('/new_order', {
            state: {
              from: '/cart',
              order: order
            }
          })
        }
      })
      .catch(error => {
        dispatch({ type: GET_PRODUCTS_FAILED });
        console.log(error);
        dispatch({
          type: SET_PORTAL_API,
          title: TITLE_ERROR,
          text: Object.values(error)
        });
      })
      .finally(() => {
        dispatch({ type: END_LOADING });
      });
  }
}
